import {createAction} from 'redux-actions';
import {getContentItemViewPublishingRights} from '@pluto/rest';
import {PublishingRights} from '../ContentItemViewPublishingRightsTypes';

export const CONTENT_ITEM_VIEW_PUBLISHING_RIGHTS_SET = 'CONTENT_ITEM_VIEW_PUBLISHING_RIGHTS_SET';
export const CONTENT_ITEM_VIEW_PUBLISHING_RIGHTS_RESET = 'CONTENT_ITEM_VIEW_PUBLISHING_RIGHTS_RESET';

export type PublishingRightsPayload = {
    id: number,
    publishingRights: PublishingRights[],
};

export const setContentItemViewPublishingRightsAction = createAction<Promise<PublishingRightsPayload>, number>(CONTENT_ITEM_VIEW_PUBLISHING_RIGHTS_SET, async (id: number) => {
    return await getContentItemViewPublishingRights(id);
});

export const resetContentItemViewPublishingRights = createAction(CONTENT_ITEM_VIEW_PUBLISHING_RIGHTS_RESET);

